module.exports = __webpack_public_path__ + "img/rtl-img.3462467b.png";